<template>
  <div id="footer">
    <div class="top-t">
      <div class="top-leftOne">
        <div class="logo">
          <img src="../assets/img/foot.png" alt="" />
          <img src="../assets/images/applogo.png" alt="" />
        </div>
        <div class="address">联系电话: 0532-68851918</div>
        <div class="address">
          青岛市区·运营总部:山东省青岛市市南区银川西路67~69号元宇宙产业创新园C座118
        </div>
        <div class="address">
          上合示范区·智捷工厂:山东省青岛市上合示范区胶州经济技术开发区滦河路10号
        </div>
      </div>
      <div class="top-left">
        <div style="font-size: 20px">整体方案</div>
        <div class="self-adaption">
          <div>方案介绍</div>
          <div>竞争优势</div>
          <div>经济模型</div>
          <div>专利布局</div>
        </div>
      </div>
      <div class="top-left">
        <div style="font-size: 20px">产品中心</div>
        <div class="no-adaption">
          <div>标准动力电池</div>
          <div>多型态电池仓</div>
          <div>通用换电柜</div>
          <div>全系换电车型</div>
          <div>全域管理系统</div>
        </div>
      </div>
      <div class="top-left">
        <div style="font-size: 20px">关于我们</div>
        <div class="no-adaption">
          <div>企业简介</div>
          <div>品牌释义</div>
          <div>新闻资讯</div>
          <div>荣誉奖项</div>
        </div>
      </div>
      <div class="top-left">
        <div style="font-size: 20px">联系我们</div>
        <div class="no-adaption">
          <div>招聘中心</div>
          <div>业务合作</div>
        </div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="bottom-t">
      <div class="bottom-zi">网安备案：隐私政策</div>
      <div class="bottom-zi">
        © 2023 青岛联合新能源汽车有限公司 &nbsp;<a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          >鲁ICP备18043946号-1</a
        >&nbsp;
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 50vh;
  color: #fff;
  background: #282b30;
  overflow: hidden;
  padding: 30px 90px;
  font-family: PingFang SC;
  /* text-align: center; */
}
.top-t {
  width: 100%;
  height: 83%;
  display: flex;
  justify-content: space-between;
}
.top-leftOne {
  width: 40%;
  height: 100%;
}
.logo {
  width: 100%;
  height: 53%;
  /* margin: 50px auto 20px; */
}
.logo img {
  height: 50%;
}
.address {
  height: 15%;
  width: 100%;
  font-size: 12px;
}
.top-left {
  width: 14%;
  height: 100%;
}
.self-adaption {
  margin-top: 10px;
  height: 80%;
  line-height: 40px;
  font-size: 12px;
  /* display: flex;
  flex-direction: column;
  justify-content: space-around; */
}
.no-adaption {
  margin-top: 10px;
  height: 80%;
  line-height: 40px;
  font-size: 12px;
}
.bottom-t {
  width: 100%;
  height: 15%;
  font-size: 12px;
}
.bottom-zi {
  width: 100%;
  height: 50%;
}
a {
  color: #fff;
  text-decoration: none;
}
::v-deep .el-divider--horizontal {
  margin: 10px 0;
}
@media screen and (max-width: 997px) {
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue